module.exports = __webpack_public_path__ + "img/hygh.e80a7102.webp";